export default class QuotationForm {
  constructor() {
    this.form = document.getElementById('QuotationForm');
    this.UseStandardAddressCheckbox = this.form.querySelector('input[type=checkbox][name=UseStandardAddress]');
    if (this.UseStandardAddressCheckbox) {
      this.TaxationStreetInput = this.form.querySelector('#QuotationForm_TaxationStreet_Holder');
      this.TaxationHousenumberInput = this.form.querySelector('#QuotationForm_TaxationHousenumber_Holder');
      this.TaxationPostcodeInput = this.form.querySelector('#QuotationForm_TaxationPostcode_Holder');
      this.TaxationResidenceInput = this.form.querySelector('#QuotationForm_TaxationResidence_Holder');
    }

    if (!this.form) {
      return;
    }

    this.setStandardAddressFields = this.setStandardAddressFields.bind(this);

    this.setStandardAddressFields();
    this._setDOMReferences();
  }

  _setDOMReferences() {
    if (this.UseStandardAddressCheckbox) {
      this.UseStandardAddressCheckbox.addEventListener('change', () => this.setStandardAddressFields());
    }
  }

  setStandardAddressFields() {
    if (!this.UseStandardAddressCheckbox) {
      return;
    }

    if (this.UseStandardAddressCheckbox.checked) {
      this.TaxationStreetInput.classList.add('hidden');
      this.TaxationHousenumberInput.classList.add('hidden');
      this.TaxationPostcodeInput.classList.add('hidden');
      this.TaxationResidenceInput.classList.add('hidden');
    } else {
      this.TaxationStreetInput.classList.remove('hidden');
      this.TaxationHousenumberInput.classList.remove('hidden');
      this.TaxationPostcodeInput.classList.remove('hidden');
      this.TaxationResidenceInput.classList.remove('hidden');
    }
  }
}
